// Arbitrary value to not overwhelm the user with visual feedback (a lot of animations is happening)
export const SHEET_CLOSE_INTO_NOTIFICATION_WAIT = 350;

export const ASSET_IMAGE_PATH = '/assets/images';

export const TRANSLATION_SETS = ['Patient', 'CommonFrontend'] as const;

export const IDP_AUTHENTICATION_PROVIDER_ID = 'OpenIdConnect' as const;

export const RED_ROBIN_SUPPORTED_LANGUAGES = ['sv', 'en', 'fi', 'no'];

export const DEFAULT_LAYOUT_VARIANT = 'shell-3';
